import { PASS_VIEWS } from '../util/constants'
export const LOCATION_CHANGE = '@@router/LOCATION_CHANGE'
export const TOGGLE_DRAWER = 'ui-control/TOGGLE_DRAWER'
export const OPEN_PAGE = 'ui-control/OPEN_PAGE'
export const VIEW_PASS_OPENED = 'ui-control/VIEW_PASS_OPENED'
export const TOGGLE_PASS_SELECT = 'ui-control/TOGGLE_PASS_SELECT'
export const TOGGLE_NEW_PASS = 'ui-control/TOGGLE_NEW_PASS'
export const SELECT_PASS_VIEW = 'ui-control/SELECT_PASS_VIEW'
const initialState = {
  drawer: {
    open: false
  },
  newPass: {
    open: false
  },
  selectedPassId: null,
  passView: PASS_VIEWS.ACTIVE
}
export default (uiControl = initialState, action) => {
  switch (action.type) {
    case LOCATION_CHANGE: {
      return {
        ...uiControl,
        drawer: { open: false }
      }
    }
    case TOGGLE_NEW_PASS:
      return {
        ...uiControl,
        newPass: {
          open: !uiControl.newPass.open
        }
      }
    case TOGGLE_DRAWER:
      return {
        ...uiControl,
        drawer: {
          open: !uiControl.drawer.open
        }
      }
    case OPEN_PAGE:
      return {
        ...uiControl,
        drawer: {
          open: false
        }
      }
    case TOGGLE_PASS_SELECT:
      const selectedPassId = uiControl.selectedPassId === action.pass_id ? initialState.selectedPassId : action.pass_id
      return {
        ...uiControl,
        selectedPassId: selectedPassId
      }
    case SELECT_PASS_VIEW:
      return {
        ...uiControl,
        passView: action.view
      }
    default:
      return { ...uiControl }
  }
}
export const toggleDrawer = (e) => {
  return dispatch => {
    dispatch({ type: TOGGLE_DRAWER });
  }
}
export const openHome = (e) => {
  return dispatch => {
    dispatch({ type: OPEN_PAGE })

  }
}
export const openResident = (e) => {
  return dispatch => {
    dispatch({ type: OPEN_PAGE })
  }
}
export const selectPassInPassList = (pass_id) => {
  return dispatch => {
    dispatch({ type: TOGGLE_PASS_SELECT, pass_id })
  }
}
export const selectPassView = (e, view) => {
  console.log(view);
  return dispatch => {
    dispatch({ type: SELECT_PASS_VIEW, view })
  }
}
export const toggleNewPassView = (e) => {
  return dispatch => {
    dispatch({ type: TOGGLE_NEW_PASS })
  }
}


// WEBPACK FOOTER //
// ./src/reducers/ui-control.js